import React from 'react';
import { UserPlus, Play, Plus, Trash2, RefreshCw, Pencil } from 'lucide-react';

const Setup = ({ 
  players, 
  playerName, 
  setPlayerName, 
  addPlayer, 
  removePlayer, 
  renamePlayer, 
  validOptions, 
  matchesPerPlayer, 
  setMatchesPerPlayer, 
  generateTournament,
  hasMatches
}) => (
  <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
    <section className="bg-slate-900 rounded-3xl p-6 border border-slate-800 shadow-xl">
      <h2 className="text-sm font-bold text-slate-500 uppercase tracking-widest mb-4 flex items-center gap-2">
        <UserPlus className="w-4 h-4 text-emerald-500" /> Lista de Atletas
      </h2>
      <div className="flex gap-2 mb-6">
        <input type="text" value={playerName} onChange={(e) => setPlayerName(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && addPlayer()} 
          placeholder="Nome do jogador..." className="flex-1 bg-slate-950 border border-slate-800 rounded-2xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-emerald-500 transition-all text-slate-200" />
        <button onClick={addPlayer} className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 p-4 rounded-2xl font-bold transition-all active:scale-95 shadow-lg shadow-emerald-500/10"><Plus /></button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-h-64 overflow-y-auto pr-2 custom-scrollbar">
        {players.map(p => (
          <div key={p} className="flex items-center justify-between bg-slate-800/40 border border-slate-800 px-4 py-3 rounded-2xl hover:border-slate-700 transition-colors">
            <span className="font-medium text-slate-300">{p}</span>
            <div className="flex items-center">
              <button onClick={() => renamePlayer(p)} className="text-slate-600 hover:text-sky-500 p-1"><Pencil className="w-4 h-4" /></button>
              <button onClick={() => removePlayer(p)} className="text-slate-600 hover:text-rose-500 p-1"><Trash2 className="w-4 h-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </section>

    <section className="bg-slate-900 rounded-3xl p-6 border border-slate-800 shadow-xl">
      <h2 className="text-sm font-bold text-slate-500 uppercase tracking-widest mb-6 flex items-center gap-2">
        <Play className="w-4 h-4 text-emerald-500" /> Grade do Torneio
      </h2>
      <div className="space-y-6">
        <div>
          <label className="text-sm text-slate-400 block mb-3">Partidas por Atleta</label>
          <div className="grid grid-cols-5 gap-2">
            {validOptions.map(opt => (
              <button key={opt} onClick={() => setMatchesPerPlayer(opt)}
                className={`py-3 rounded-xl font-bold transition-all text-sm border-2 ${matchesPerPlayer === opt ? 'bg-emerald-500 border-emerald-400 text-slate-950 shadow-inner' : 'bg-slate-950 border-slate-800 text-slate-500 hover:border-slate-700'}`}>{opt}</button>
            ))}
          </div>
        </div>
        <button 
          onClick={generateTournament} 
          disabled={players.length < 4 || validOptions.length === 0}
          className="w-full bg-emerald-500 hover:bg-emerald-400 disabled:bg-slate-800 disabled:text-slate-600 text-slate-950 py-5 rounded-2xl font-black text-lg shadow-xl shadow-emerald-500/10 uppercase tracking-tighter transition-all flex items-center justify-center gap-3"
        >
          {hasMatches ? <RefreshCw className="w-5 h-5" /> : <Play className="w-5 h-5" />}
          {hasMatches ? 'Atualizar Torneio' : 'Gerar Torneio'}
        </button>
      </div>
    </section>
  </div>
);

export default Setup;
